/**
 * EE feature 菜单增量（与 CE src/constants/ceFeatureMenus.js merge）。
 * - 已有 CE key：通常只写 eeMenus，ceMenus 自动用 CE
 * - EE 独有 feature：写完整 ceMenus（可为空）+ eeMenus
 * - 仅当必须改写某 key 的 ceMenus 时才显式覆盖 ceMenus
 */
export const FEATURE_MENUS = {
  onestack: {
    eeMenus: ['topology', 'navbar-shopcarts', 'credentials-enc-key'],
  },
  pod: {
    eeMenus: ['topology'],
  },
  ai: {
    eeMenus: ['mcp', 'navbar-ai'],
  },
  baremetal: {
    eeMenus: ['topology'],
  },
  aliyun: {
    eeMenus: ['navbar-shopcarts'],
  },
  aws: {
    eeMenus: ['navbar-shopcarts'],
  },
  azure: {
    eeMenus: ['navbar-shopcarts'],
  },
  ctyun: {
    eeMenus: ['navbar-shopcarts'],
  },
  google: {
    eeMenus: ['navbar-shopcarts'],
  },
  huawei: {
    eeMenus: ['modelarts', 'navbar-shopcarts'],
  },
  qcloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  ucloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  rockbase: {
    eeMenus: ['navbar-shopcarts'],
  },
  ecloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  jdcloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  cloudflare: {
    eeMenus: ['ai-gateway'],
  },
  baidu: {
    eeMenus: ['navbar-shopcarts'],
  },
  ksyun: {
    eeMenus: ['navbar-shopcarts'],
  },
  volcengine: {
    eeMenus: ['navbar-shopcarts'],
  },
  oraclecloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  vmware: {
    eeMenus: ['navbar-shopcarts'],
  },
  openstack: {
    eeMenus: ['navbar-shopcarts'],
  },
  zstack: {
    eeMenus: ['navbar-shopcarts'],
  },
  apsara: {
    eeMenus: ['navbar-shopcarts'],
  },
  cloudpods: {
    eeMenus: ['navbar-shopcarts'],
  },
  hcso: {
    eeMenus: ['navbar-shopcarts', 'modelarts'],
  },
  hcsop: {
    eeMenus: ['navbar-shopcarts'],
  },
  hcs: {
    eeMenus: ['navbar-shopcarts'],
  },
  nutanix: {
    eeMenus: ['navbar-shopcarts'],
  },
  bingocloud: {
    eeMenus: ['navbar-shopcarts'],
  },
  incloudsphere: {
    eeMenus: ['navbar-shopcarts'],
  },
  remotefile: {
    eeMenus: ['navbar-shopcarts'],
  },
  proxmox: {
    eeMenus: ['navbar-shopcarts'],
  },
  h3c: {
    eeMenus: ['navbar-shopcarts'],
  },
  zettakit: {
    eeMenus: ['navbar-shopcarts', 'topology'],
  },
  uis: {
    eeMenus: ['navbar-shopcarts'],
  },
  sangfor: {
    eeMenus: ['navbar-shopcarts'],
  },
  cnware: {
    eeMenus: ['navbar-shopcarts'],
  },
  monitor: {
    eeMenus: ['navbar-monitor-dashboard'],
  },
  report: {
    ceMenus: [],
    eeMenus: ['report-element', 'report-setting', 'report-template', 'month-report-subscription', 'daily-report-subscription', 'deadly-resource'],
  },
  extdb: {
    ceMenus: [],
    eeMenus: ['custom-data', 'resource-type-setting'],
  },
  bastionhost: {
    ceMenus: [],
    eeMenus: ['bastion-host'],
  },
  bill_private: {
    ceMenus: [],
    eeMenus: ['billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'resource-tag', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_kubernetes: {
    ceMenus: [],
    eeMenus: ['billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting', 'resource-tag'],
  },
  bill_extdb: {
    ceMenus: [],
    eeMenus: ['billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'resource-tag', 'alert', 'alert-setting'],
  },
  suggestion: {
    ceMenus: [],
    eeMenus: ['suggestsyoverview', 'suggestsysrule', 'suggestsysalert', 'suggestsysruleconfig', 'suggestsysreport'],
  },
  bill_aliyun: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_aws: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_azure: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_google: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_huawei: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_qcloud: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_jdcloud: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_volcengine: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  bill_ksyun: {
    ceMenus: ['cloudaccount', 'cloudgroup', 'proxysetting', 'projectmapping'],
    eeMenus: ['bill-product', 'billoverview', 'billaccount', 'billstatistic', 'billdomain', 'billproject', 'billtag', 'billtime', 'billresourcetype', 'billoriginresourcetype', 'billexternalproject', 'billproducttype', 'billanalysis', 'billanalysis-report', 'billanalysis-alarm', 'budget', 'predict', 'billsummary', 'bill-monthlydetail', 'bill-dailydetail', 'offline-export', 'pricecomparator', 'billrate', 'cost-conversion', 'billexchangerate', 'bill-config', 'alert', 'alert-setting'],
  },
  auth: {
    eeMenus: ['organization', 'iam/suggestsysalert', 'iam/suggestsysruleconfig', 'iam/suggestsysrule', 'navbar-workflow', 'navbar-user', 'navbar-theme', 'credentials-oidc', 'log', 'log-manage', 'cloudevent', 'command-log', 'thirdparty', 'processmanage'],
  },
}

export const MENU_TAGS = {
  vminstance: ['主机', '云主机', 'server'],
}
